module.exports = __webpack_public_path__ + "static/media/Controle_inteligente-ASSETS.a94aab6d.zip";